<template>
  <div class="main">
    <DetailsMenu :user="user" title="User Details" current="Wishlist" />
    <div class="content p-3 p-md-4 px-xxl-5">
      <div class="row">
        <div class="col-12">
          <transition name="fade">
            <Alert v-if="hasAlert" :alert="alert" />
          </transition>
        </div>
      </div>

      <!-- WISHLIST -->
      <div class="row">
        <div
            :class="{
                  'col-12': !showDetailsPane,
                  'col-8 details-pane-open': showDetailsPane,
                }"
        >
          <ListTable
              :items="items"
              :columns="columns"
              :activeColumns="activeColumns"
              :hideNoResults="hideNoResults"
              :hasDetailsPane="showDetailsPane"
              @sort-by="setSort"
              @swap-column="setActiveColumn"
              @item-clicked="setSelectedItem"
          >
            <template v-slot:list-card="{ item, id }">
              <ListCard :item="item" :id="id" :eventBus="listEvents" />
            </template>
            <template v-slot:list-menu="{ item, id }">
              <ListMenu :item="item" :id="id" :eventBus="listEvents" />
            </template>
          </ListTable>
        </div>
        <div v-if="showDetailsPane" class="col-4 details-pane-wrap mb-3">
          <DetailsPane
              :course="selectedItem"
              @close="setSelectedItem(null)"
          />
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import DisplaysAlerts from "mixins/DisplaysAlerts";
import ListingMixin from "mixins/Listing";
import ListCard from "components/partials/Courses/ListCard";
import ListMenu from "components/partials/Courses/ListMenu";
import DetailsMenu from "./partials/DetailsMenu";
import DetailsPane from "components/partials/Courses/DetailsPane";
import FormWrapper from "../../../forms/FormWrapper.vue";
import TrainingMenu from "../partials/TrainingMenu.vue";

export default {
  mixins: [DisplaysAlerts,ListingMixin],
  components: {
    TrainingMenu,
    FormWrapper,
    DetailsMenu,
    DetailsPane,
    ListCard,
    ListMenu,
  },
  props: {
    user: { type: Object, required: true },
  },
  data() {
    return {};
  },
  mounted() {
    this.listEvents.$on("show-alert", this.showAlert);
    this.listEvents.$on("show-details-pane", this.setSelectedItem);
  },
};
</script>